import {
  ComponentParams,
  ComponentRendering,
  Field,
  Item,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { KeyValuePair, AnchorTargetParams, TranslationOptionsParams } from '@/shared/shared.types';

export type OverlineTagItem = Omit<Item, 'fields'> & {
  fields?: {
    'Tag Name'?: Field<string>;
    Icon?: KeyValuePair;
  };
};

export type C35OverlineIconsRouteFields = {
  'Department Type'?: OverlineTagItem[];
  Campus?: OverlineTagItem[];
  FacultyLabs?: OverlineTagItem[];
  'Technology for License Type'?: OverlineTagItem[];
  'Technology for License Clinical Area'?: OverlineTagItem[];
};

export type C35OverlineIconsParams = AnchorTargetParams & TranslationOptionsParams;

export interface C35OverlineIconsProps {
  rendering?: ComponentRendering & { params?: Partial<ComponentParams & C35OverlineIconsParams> };
  params?: Partial<ComponentParams & C35OverlineIconsParams>;
}
